import { FC } from 'react';
import { Link } from 'react-router-dom';
import img404 from 'assets/svg/layout-404-bg.svg';
import { MAIN_PAGE } from 'shared/consts';
import { LayoutNotFound } from 'widgets/index';

import styles from './styles.module.scss';

export const PageError: FC = () => {
  return (
    <LayoutNotFound>
      <div className={styles['page']}>
        <img className={styles['page__banner']} src={img404} alt="404" />
        <span className={styles['page__message']}>
          Видимо мы нечаянно удалили её... или специально.
          <br />А вы возвращайтесь на{' '}
          <Link to={MAIN_PAGE}>Главную страницу</Link>
        </span>
      </div>
    </LayoutNotFound>
  );
};
